export default {
  CREDIT_CARD_AUTHORIZATION_RULE: 'CreditCardAuthorizationRule',
};
